import { render } from "./SidingPage.vue?vue&type=template&id=7461db7a&scoped=true"
import script from "./SidingPage.vue?vue&type=script&lang=js"
export * from "./SidingPage.vue?vue&type=script&lang=js"

import "./SidingPage.vue?vue&type=style&index=0&id=7461db7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7461db7a"]])

export default __exports__